/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import NProgress from 'nprogress'
import { paramToDate } from '../../util/DateString'
import ReceptionistView from '../../view/pages/reservations/ReceptionistView'
import ReservationsStore from '../../store/reservation/ReservationsStore'
import ReservationStore from '../../store/reservation/ReservationStore'
import ReceptionistStore from '../../store/reservation/ReceptionistStore'
import ReceptionistSearchStore from '../../store/reservation/ReceptionistSearchStore'
import ReservationAction from '../../action/reservation'
import ReceptionistAction from '../../action/reservation/receptionist'
import SessionStore from '../../store/SessionStore'
import AuditsStore from '../../store/AuditsStore'
import AutoActionLogsStore from '../../store/auto_action/AutoActionLogsStore'
import AccommodationInvoicesStore from '../../store/reservation/AccommodationInvoicesStore'
import SessionAction from '../../action/session'

class ReceptionistContainer extends Component {
  static getStores() {
    return [ReceptionistStore, ReceptionistSearchStore, ReservationStore, ReservationsStore, AccommodationInvoicesStore, AuditsStore, AutoActionLogsStore, SessionStore]
  }

  static calculateState(prevState, props) {
    return {
      receptionist: ReceptionistStore.getState(),
      reservations: ReservationsStore.getState(),
      search: ReceptionistSearchStore.getState(),
      reservation: ReservationStore.getState(),
      invoices: AccommodationInvoicesStore.getState(),
      audits: AuditsStore.getState(),
      auto_action_logs: AutoActionLogsStore.getState(),
      session: SessionStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    // ReservationDetail
    const id = this.state.match.params.id
    if (id) {
      const tab = _.propertyOf(this.state.match.params)('tab')
      await ReservationAction.getReservation(tab, id)
      NProgress.done()
      return
    }

    const dateParam = this.state.match.params.date

    if (dateParam && paramToDate(dateParam)) {
      const date = paramToDate(dateParam)
      const searchCondition = this.state.search.set('search_date', date)
      await ReceptionistAction.onSearch(searchCondition)
    } else {
      //dateが指定されていなければデフォルトで当日を挿入してdateChangeさせる
      const date = new Date()
      await ReservationAction.dateChange(date)
    }
    await SessionAction.fetchUserHotels()
    NProgress.done()
  }

  render() {
    return ReceptionistView(this.state)
  }
}

export default withRouter(Container.create(ReceptionistContainer, { withProps: true }))
